import { UserCheck, UserCog, BookOpen, Briefcase } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import ScrollAnimation from './ScrollAnimation';

const ServicesSection = () => {
  const services = [
    {
      icon: <UserCheck size={40} className="text-primary-600" />,
      title: 'Rekrutmen Tenaga Kerja',
      description:
        'Kami menyediakan tenaga kerja berkualitas yang sesuai dengan kebutuhan spesifik perusahaan Anda melalui proses seleksi yang ketat.',
    },
    {
      icon: <UserCog size={40} className="text-primary-600" />,
      title: 'Manajemen Tenaga Kerja',
      description:
        'Kami mengelola seluruh aspek administratif tenaga kerja termasuk penggajian, kontrak, dan kepatuhan terhadap regulasi ketenagakerjaan.',
    },
    {
      icon: <BookOpen size={40} className="text-primary-600" />,
      title: 'Pengembangan Keterampilan',
      description:
        'Program pelatihan komprehensif untuk meningkatkan keterampilan tenaga kerja sesuai dengan standar industri dan kebutuhan perusahaan.',
    },
    {
      icon: <Briefcase size={40} className="text-primary-600" />,
      title: 'Konsultasi SDM',
      description:
        'Layanan konsultasi profesional untuk membantu perusahaan mengoptimalkan strategi pengelolaan sumber daya manusia mereka.',
    },
  ];

  return (
    <section className="py-20">
      <div className="container-custom">
        <ScrollAnimation>
          <div className="text-center mb-16">
            <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
              Layanan Kami
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
              Kami menawarkan berbagai layanan tenaga kerja komprehensif untuk memenuhi kebutuhan bisnis Anda.
            </p>
          </div>
        </ScrollAnimation>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <ScrollAnimation key={index} delay={index * 0.15}>
              <div className="card p-6 hover:translate-y-[-8px] group">
                <div className="mb-5">{service.icon}</div>
                <h3 className="text-xl font-bold mb-3 group-hover:text-primary-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <NavLink
                  to="/services"
                  className="text-primary-600 font-medium hover:text-primary-700 inline-flex items-center"
                >
                  <span>Selengkapnya</span>
                  <svg
                    className="w-4 h-4 ml-1 transition-transform duration-300 group-hover:translate-x-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </NavLink>
              </div>
            </ScrollAnimation>
          ))}
        </div>

        <ScrollAnimation delay={0.6}>
          <div className="text-center mt-12">
            <NavLink to="/services" className="btn btn-primary">
              Lihat Semua Layanan
            </NavLink>
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
};

export default ServicesSection;